PJQ.views.punchlists.PunchListSettingsModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PUNCHLISTS, 'Modal-Punch-List-Settings'),
		subTemplates: {},
		maxWidth: 500,
		onSave: _.noop
	},
	events: {
		'change .select-column': 'columnSelected',
		'click .settings-save': 'onSave',
		'click .btn-delete-punch-lists': 'deleteItems'
	},
	afterModalCreated: function () {
		new PJQ.Loader(this.$('.modal-body'));
		PJQ.app.session.project.fetchProjectContacts(_.bind(function(projectContacts){
			this.projectContacts = projectContacts;
			PJQ.app.session.project.fetchPunchListSettings(_.bind(function (settings) {
				this.model = settings;
				this.render();
			}, this));
		}, this))
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model,
			project: this.options.project
		};
	},
	afterRender: function () {
		if(this.model){
			new PJQ.views.contacts.ContactsSelectInput({
				el: this.$('.punch-list-creators'),
				contacts: this.projectContacts,
				selectedContact: this.model.projectContacts.filter(function(projectContact){
					return projectContact.get('canAdd');
				}),
				isSingleChoice: false,
				onAdd: _.bind(function (contacts) {
					this.updateProjectContactsSetting(contacts, 'canAdd', true);
				}, this),
				onDelete: _.bind(function (contact) {
					this.updateProjectContactsSetting(contact, 'canAdd', false);
				}, this)
			});

			new PJQ.views.contacts.ContactsSelectInput({
				el: this.$('.punch-list-notify-created'),
				contacts: this.projectContacts,
				selectedContact: this.model.projectContacts.filter(function(projectContact){
					return projectContact.get('notifyAdded');
				}),
				isSingleChoice: false,
				onAdd: _.bind(function (contacts) {
					this.updateProjectContactsSetting(contacts, 'notifyAdded', true);
				}, this),
				onDelete: _.bind(function (contact) {
					this.updateProjectContactsSetting(contact, 'notifyAdded', false);
				}, this)
			});

			new PJQ.views.contacts.ContactsSelectInput({
				el: this.$('.punch-list-notify-comment'),
				contacts: this.projectContacts,
				selectedContact: this.model.projectContacts.filter(function(projectContact){
					return projectContact.get('notifyComment');
				}),
				isSingleChoice: false,
				onAdd: _.bind(function (contacts) {
					this.updateProjectContactsSetting(contacts, 'notifyComment', true);
				}, this),
				onDelete: _.bind(function (contact) {
					this.updateProjectContactsSetting(contact, 'notifyComment', false);
				}, this)
			});


			new PJQ.views.contacts.ContactsSelectInput({
				el: this.$('.punch-list-notify-work-completed'),
				contacts: this.projectContacts,
				selectedContact: this.model.projectContacts.filter(function(projectContact){
					return projectContact.get('notifyWorkCompleted');
				}),
				isSingleChoice: false,
				onAdd: _.bind(function (contacts) {
					this.updateProjectContactsSetting(contacts, 'notifyWorkCompleted', true);
				}, this),
				onDelete: _.bind(function (contact) {
					this.updateProjectContactsSetting(contact, 'notifyWorkCompleted', false);
				}, this)
			});

			new PJQ.views.contacts.ContactsSelectInput({
				el: this.$('.punch-list-notify-not-resolved'),
				contacts: this.projectContacts,
				selectedContact: this.model.projectContacts.filter(function(projectContact){
					return projectContact.get('notifyNotResolved');
				}),
				isSingleChoice: false,
				onAdd: _.bind(function (contacts) {
					this.updateProjectContactsSetting(contacts, 'notifyNotResolved', true);
				}, this),
				onDelete: _.bind(function (contact) {
					this.updateProjectContactsSetting(contact, 'notifyNotResolved', false);
				}, this)
			});

			new PJQ.views.contacts.ContactsSelectInput({
				el: this.$('.punch-list-notify-resolved'),
				contacts: this.projectContacts,
				selectedContact: this.model.projectContacts.filter(function(projectContact){
					return projectContact.get('notifyResolved');
				}),
				isSingleChoice: false,
				onAdd: _.bind(function (contacts) {
					this.updateProjectContactsSetting(contacts, 'notifyResolved', true);
				}, this),
				onDelete: _.bind(function (contact) {
					this.updateProjectContactsSetting(contact, 'notifyResolved', false);
				}, this)
			});

			this.rowsPerPageSelectPicker = new PJQ.inputs.Selectpicker({
				el: this.$('.rows-per-page'),
				defaultValue: this.options.userSettings.getSettings(PJQ.constants.punchlists.view.PUNCHLISTS).rowsPerPage,
				onChange: _.bind(function (value) {
					this.onChange();
				}, this)
			});

			this.dataTable = new PJQ.views.dataTables.DataTable({
				el: this.$('div.column-settings'),
				data: this.options.punchlistsView.getColumns(true),
				isHideSearch: true,
				order: [],
				columns: [
					{"data": "title", "title": "Column", "orderable": false},
					{
						"data": "visible",
						"title": "Show",
						"orderable": false,
						"searchable": false,
						"render": _.bind(function (data) {
							return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
						}, this),
						"width": '10%'
					}
				],
				dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
			});

		}
	},
	deleteItems: function() {
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete all punch list items on this project?",
			onDelete: _.bind(function () {
				this.options.project.deleteAllPunchLists(_.bind(function () {
					this.options.punchlistsView.collection.remove(this.options.punchlistsView.collection.models);
					if (typeof this.options.onSave === 'function') {
						this.options.onSave(this.model);
					}
					this.removeModal();
				}, this));
			}, this)
		});
	},
	columnSelected: function (sender) {
		this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
	},
	updateProjectContactsSetting: function(contacts, setting, value){
		contacts = PJQ.helpers.objectHelpers.refinedType(contacts) === 'array' ? contacts : [contacts];
		_.each(contacts, _.bind(function(contact){
			let existingSetting = this.model.projectContacts.findWhere({ id: contact.id });
			if(existingSetting != null){
				existingSetting.set(setting, value);
			}
			else{
				let newSetting = new PJQ.models.punchlists.ProjectContactSetting(contact.attributes);
				newSetting.set(setting, value);
				this.model.projectContacts.add(newSetting);
			}
		}, this));
	},
	onSave: function () {
		let loader = new PJQ.Loader(this.$('.modal-content'));

		this.options.punchlistsView.options.userSettings.getSettings(PJQ.constants.punchlists.view.PUNCHLISTS).rowsPerPage = parseInt(this.rowsPerPageSelectPicker.getValue());
		let columns = this.options.punchlistsView.options.userSettings.getSettings(PJQ.constants.punchlists.view.PUNCHLISTS).columns;
		_.each(this.dataTable.dataTable.data(), function (row) {
			if (row.visible) {
				if (columns.indexOf(row.columnData) === -1)
					columns.push(row.columnData);
			}
			else {
				columns = _.filter(columns, function(column) {
					return (column != row.columnData);
				});
			}
		});
		this.options.punchlistsView.options.userSettings.getSettings(PJQ.constants.punchlists.view.PUNCHLISTS).columns = columns;

		this.options.punchlistsView.options.userSettings.save(null, {
			success: _.bind(function() {
				this.model.put(null, {
					success: _.bind(function () {
						this.options.onSave();
						this.removeModal();
					}, this),
					error: function () {
						loader.remove();
					}
				});
			}, this)
		});
	}
});